<template>
  <ButtonCircleIcon
    class="delete"
    icon-name="trash"
    size="small"
    icon-size="2rem"
    stroke="m"
    theme="warning"
    aria-label="Supprimer l'évaluation"
    @click="handleClickDelete"
  />
</template>
<script setup lang="ts">
interface Props {
  uuid: string;
}

const props = defineProps({
  uuid: null
});

const assessmentDelete = useAssessmentDelete(props.uuid);

const handleClickDelete = () => {
  assessmentDelete.openDeleteDialog();
};
</script>
